var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.planing-team-validate.add_workshift"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      "loading-primary-footer-button": _vm.isLoading,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.secondaryEvent,
      _vm.onCloseButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _vm.employeeInitialized
              ? _c("div", { staticClass: "portal-employee-card" }, [
                  _c(
                    "div",
                    {
                      staticClass: "portal-employee-card__icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_c("i", { staticClass: "fas fa-user" })]
                  ),
                  _c("div", { staticClass: "portal-employee-card__meta" }, [
                    _c("span", { staticClass: "portal-employee-card__label" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("pages.planing-team-validate.employee_name")
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "strong",
                      { staticClass: "portal-employee-card__name" },
                      [_vm._v(_vm._s(_vm.employee.fullName))]
                    ),
                  ]),
                ])
              : _vm._e(),
            _c("suc-form-has-error", { attrs: { form: _vm.form } }),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("work-shift-list-field", {
                    attrs: { form: _vm.form, name: "calendar" },
                  }),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("start-date-workshift-field", {
                    attrs: {
                      form: _vm.form,
                      name: "startDate",
                      id: "startDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("end-date-workshift-field", {
                    attrs: { form: _vm.form, name: "endDate", id: "endDate" },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }